import { ChevronLeft } from '@gds/Icons/Paths/ChevronLeft';
import { PlusCircle } from '@gds/Icons/Paths/PlusCircle';
import { Search } from '@gds/Icons/Paths/Search';
import { Input } from '@gds/Input/Input';

import styles from './SearchInput.module.css';

type SearchInputProps = {
  handleSearchChange: (value: string) => void;
  searchValue: string;
  placeholder: string;
  isSearching: boolean;
  searchIsActive: boolean;
  triggerSearch: (searching: boolean) => void;
  parentId?: string;
};

const Icon = (searchIsActive: boolean, triggerSearch: (searching: boolean) => void) => {
  return (
    <div className={styles.icon}>
      <div className={styles.default}>
        <Search data-id="search-icon" />
      </div>
      <div className={styles.mobile}>
        {searchIsActive ? (
          <ChevronLeft onClick={() => triggerSearch(false)} />
        ) : (
          <Search data-id="search-icon" />
        )}
      </div>
    </div>
  );
};

const SearchInput = ({
  handleSearchChange,
  searchValue,
  placeholder,
  isSearching,
  searchIsActive,
  triggerSearch,
  parentId,
}: SearchInputProps) => {
  const clearSearch = () => handleSearchChange('');

  const iconProps = isSearching
    ? {
        rightIcon: (
          <PlusCircle
            onClick={clearSearch}
            dataTestId="close-button"
            className={styles.clearIcon}
          />
        ),
      }
    : {};

  return (
    <div className={styles.searchWrapper}>
      <Input
        onMouseDown={() => triggerSearch(true)}
        id={`${parentId || 'unknown-component'}-plp-filter-search`}
        name="search"
        value={searchValue}
        placeholder={placeholder}
        leftIcon={<Icon searchIsActive={searchIsActive} triggerSearch={triggerSearch} />}
        onChange={event => handleSearchChange(event.target.value)}
        autoComplete="off"
        aria-label={placeholder}
        dataTestId="search-input"
        {...iconProps}
        fullWidth
      />
    </div>
  );
};

export default SearchInput;
